import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const isBrowser = typeof window !== "undefined";
export const PUSH_SUPPORTED =
  isBrowser &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function getPermissionState() {
  if (!PUSH_SUPPORTED) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function isSubscribed() {
  if (!PUSH_SUPPORTED) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch { return false; }
}

export async function registerServiceWorker() {
  if (!PUSH_SUPPORTED) return null;
  return navigator.serviceWorker.register("/sw.js", { scope: "/" });
}

export async function subscribe() {
  if (!PUSH_SUPPORTED) throw new Error("Push non supportate");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso negato");

  const reg = await registerServiceWorker();
  if (!reg) throw new Error("SW non registrato");
  await navigator.serviceWorker.ready;

  let pubKey = process.env.REACT_APP_VAPID_PUBLIC_KEY || "";
  if (!pubKey) {
    const { data } = await axios.get(`${API}/push/public-key`);
    pubKey = data?.public_key || "";
  }
  if (!pubKey) throw new Error("VAPID public key mancante");

  const existing = await reg.pushManager.getSubscription();
  const sub = existing || await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(pubKey),
  });
  await axios.post(`${API}/push/subscribe`, { subscription: sub.toJSON() });
  return sub;
}

export async function unsubscribe() {
  if (!PUSH_SUPPORTED) return;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try { await axios.post(`${API}/push/unsubscribe`, { endpoint: sub.endpoint }); } catch (err) { console.debug("[push]", err); }
  await sub.unsubscribe();
}

export async function triggerHighPriorityPush() {
  try { await axios.post(`${API}/push/trigger`); } catch (err) { console.debug("[push]", err); }
}
